import { inject, Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

export enum PlatformType {
  desktopweb = 'desktopweb',
  mobileweb = 'mobileweb',
}

@Injectable({
  providedIn: 'root',
})
export class PlatformInfoService {
  private platform = inject(Platform);

  getPlatform(): PlatformType {
    if (this.platform.is('desktop')) {
      return PlatformType.desktopweb;
    }
    return PlatformType.mobileweb;
  }

  isMobile(): boolean {
    return this.platform.is('mobile');
  }
}
